import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";



export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand" aria-label="Migarda home">
          <img src="/image2.png" alt="Migarda" className="brand-image" />
        </Link>

        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          aria-controls="main-navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((s) => !s)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
          <span className="sr-only">Menu</span>
        </button>

        <nav
          id="main-navigation"
          className={`main-nav ${menuOpen ? "open" : ""}`}
          aria-label="Main navigation"
        >
          <Link to="/" className="nav-link" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/about" className="nav-link" onClick={closeMenu}>
            About Us
          </Link>
          <Link to="/teams" className="nav-link" onClick={closeMenu}>
            Gallery
          </Link>
          {(
            <Link to="/business" className="nav-link" onClick={closeMenu}>
              Business
            </Link>
          )}
          <Link to="/locations" className="nav-link" onClick={closeMenu}>
            Locations
          </Link>
          <Link to="/jobs" className="nav-link" onClick={closeMenu}>
            Careers
          </Link>
          <Link to="/contact" className="nav-link" onClick={closeMenu}>
            Contact Us
          </Link>
          {/* <Link to="/hr" className="nav-link" onClick={closeMenu}>
            HR Login
          </Link> */}
        </nav>
      </div>
    </header>
  );
}


